<script>
import DropDown from '../reUse/DropDown.vue';
import LogUrejanja from "./Log_urejanja.vue";
import Notification from '../reUse/Notification.vue';
import { i18n } from '@/i18n'
import sl from '@/Prevodi/Log-sl.json';
import en from '@/Prevodi/Log-en.json';
import it from '@/Prevodi/Log-it.json';
export default {
  components: {
    DropDown,
    LogUrejanja,
    Notification,
  },
  props: {},
  emits: ['odjava'],
  data() {
    return {
      prevodi: false,
      prikaz: 'brisanje',
      jadralna: [],
      motorna: [],
      izbranZapis: [],
      izbranPregled: 'jadralna',
      text: '',
      types: '',
      ShowNoti: false,
    }
  },
  created() {
    this.loadTranslationsDirekt('sl', sl);
    this.loadTranslationsDirekt('en', en);
    this.loadTranslationsDirekt('it', it);
    this.prevodi = true;
  },
  mounted() {
    this.Read();
  },
  computed: {},
  methods: {
    Read() {
      axios.get('./api/log/brisanja/izpis/', {withCredentials: true}).then((response) => {
        this.jadralna = response.data.jadralni;
        this.motorna = response.data.motorni;
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri pridobivanju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri pridobivanju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    OpenView(podatki, id) {
      if (podatki === 'j') {
        this.izbranPregled = 'jadralna';
        this.izbranZapis = this.jadralna.filter(p => p.id === id);
      } else {
        this.izbranPregled = 'motorna';
        this.izbranZapis = this.motorna.filter(p => p.id === id);
      }

      $(this.$refs.modalIzbrisanih).modal('show');
    },
    DetailsOff() {
      $(this.$refs.modalIzbrisanih).modal('hide');
    },
    async loadTranslations(lang, path) {
      const response = await fetch(path);
      const json = await response.json();
      i18n.global.mergeLocaleMessage(lang, json);
      // this.$i18n.mergeLocaleMessage(lang, json);
    },
    loadTranslationsDirekt(lang, messages) {
      i18n.global.mergeLocaleMessage(lang, messages)
    },
    changeLang(lang) {
      i18n.global.locale.value = lang
    },
  }
}
</script>
<template>
  <div class="pregled-povrsin-container">

    <!-- Header -->
    <div class="modern-header">
      <div class="header-content">

        <!-- Back -->
        <div class="header-section header-left">
          <button
              class="back-btn"
              @click.prevent="$router.push('/')"
          >
            <i class="fas fa-arrow-left"></i>
            <span>{{ $t('main.nazaj') }}</span>
          </button>
        </div>

        <!-- Title -->
        <div class="header-section header-center">
          <h1 class="page-title">
            {{ $t('main.title') }}
          </h1>
        </div>

        <!-- Tabs -->
        <div class="header-section header-right">
          <div class="nav-tabs">

            <button
                class="nav-tab"
                :class="{ active: prikaz === 'brisanje' }"
                @click="prikaz = 'brisanje'"
                data-umami-event="Log-brisanje"
            >
              <i class="fas fa-trash-alt"></i>
              <span>{{ $t('navs.brisanje') }}</span>
            </button>

            <button
                class="nav-tab"
                :class="{ active: prikaz === 'urejanje' }"
                @click="prikaz = 'urejanje'"
                data-umami-event="Log-urejanje"
            >
              <i class="fas fa-history"></i>
              <span>{{ $t('navs.urejanje') }}</span>
            </button>

          </div>
        </div>

      </div>
    </div>

  </div>


  <!-- Notification -->
  <Transition name="fade">
    <Notification
        v-if="ShowNoti"
        :message="text"
        :type="types"
        @closeNotification="ShowNoti = false"
    />
  </Transition>


  <!-- Log urejanja -->
  <log-urejanja v-if="prikaz === 'urejanje'" />


  <!-- Brisanje -->
  <div class="deleted-flights-container" v-else>

    <!-- Jadralni leti -->
    <section class="flight-section">

      <div class="section-header">
        <div class="section-icon glider">
          <i class="fas fa-paper-plane"></i>
        </div>

        <div>
          <h2>{{ $t('table.titleJ') }}</h2>
          <span>{{ jadralna.length }} zapisov</span>
        </div>
      </div>


      <div class="flight-list">

        <div
            class="flight-item"
            v-for="(id, index) in jadralna"
            :key="id.id"
            @click.prevent="OpenView('j', id.id)"
        >

          <div class="flight-date">
            <i class="far fa-calendar-alt"></i>
            <span>{{ id.datum_brisanja }}</span>
          </div>

          <div class="flight-user">
            <span class="label">Izbrisal</span>
            <strong>{{ id.izbrisal }}</strong>
          </div>

          <div class="flight-task">
            <span class="label">Naloga</span>
            <strong>{{ id.naloga }}</strong>
          </div>

          <div class="flight-action">
            <i class="fas fa-chevron-right"></i>
          </div>

        </div>

        <div v-if="!jadralna.length" class="empty-state">
          <i class="far fa-folder-open"></i>
          <span>Ni podatkov</span>
        </div>

      </div>

    </section>


    <!-- Motorni leti -->
    <section class="flight-section">

      <div class="section-header">
        <div class="section-icon motor">
          <i class="fas fa-plane"></i>
        </div>

        <div>
          <h2>{{ $t('table.titleM') }}</h2>
          <span>{{ motorna.length }} zapisov</span>
        </div>
      </div>


      <div class="flight-list">

        <div
            class="flight-item"
            v-for="(id, index) in motorna"
            :key="id.id"
            @click.prevent="OpenView('m', id.id)"
        >

          <div class="flight-date">
            <i class="far fa-calendar-alt"></i>
            <span>{{ id.datum_brisanja }}</span>
          </div>

          <div class="flight-user">
            <span class="label">Izbrisal</span>
            <strong>{{ id.izbrisal }}</strong>
          </div>

          <div class="flight-task">
            <span class="label">Naloga</span>
            <strong>{{ id.naloga }}</strong>
          </div>

          <div class="flight-action">
            <i class="fas fa-chevron-right"></i>
          </div>

        </div>

        <div v-if="!motorna.length" class="empty-state">
          <i class="far fa-folder-open"></i>
          <span>Ni podatkov</span>
        </div>

      </div>

    </section>

  </div>

  <!-- ODMIK OD CAPTCHE -->
  <div class='col-12 p-5'></div>
  <div class='col-12 p-2'></div>
  <!-- OBRAČUN PODROBNO -->
  <div class="modal modal-kartica" ref="modalIzbrisanih" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content list-dark border-orange" v-if="izbranZapis.length > 0">
        <div class='d-flex justify-content-end'>
          <button class="modern-close-btn mt-2 me-2" @click.prevent="DetailsOff">
            <span aria-hidden="true"><i class="fas fa-2x fa-times"></i></span>
          </button>
        </div>
        <div class='modal-header'>
          <h5 class="card-title"><i class="fas fa-plane"></i> {{$t('modal.izbrisal')}} {{izbranZapis[0].izbrisal}}</h5>
        </div>
        <div class="modal-body col-12" style="overflow-y: scroll;">
          <!-- MOTORNA PODROBNO -->
          <ul class='list-group list-group-flush' v-if="izbranPregled == 'motorna'">
            <li class='list-group-item list-dark'>{{$t('modal.reg')}} {{izbranZapis[0].registracija}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.vlecno')}} <i class="fas" :class="{'fa-times': !izbranZapis[0].vlecno, 'fa-check': izbranZapis[0].vlecno }"></i></li>
            <li class='list-group-item list-dark'>{{$t('modal.pilot')}} {{izbranZapis[0].pilot}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.instruktor')}} {{izbranZapis[0].instruktor}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.namen')}} {{izbranZapis[0].namen}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.naloga')}} {{izbranZapis[0].naloga}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.krajV')}} {{izbranZapis[0].kraj_vzleta}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.krajP')}} {{izbranZapis[0].kraj_pristanka}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.casV')}} {{izbranZapis[0].cas_vzleta}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.casP')}}{{izbranZapis[0].cas_pristanka}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.casL')}} {{izbranZapis[0].cas_letenja}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.stPristankov')}}{{izbranZapis[0].st_pristankov}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.ifr')}} {{izbranZapis[0].ifr}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.nocno')}} {{izbranZapis[0].nocno}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.vizuelno')}} {{izbranZapis[0].vizuelno}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.opomba')}} {{izbranZapis[0].tip}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.datumL')}} {{izbranZapis[0].datum}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.datumV')}} {{izbranZapis[0].datum_vnosa}}</li>
            <li class='list-group-item border-lorange'>{{$t('modal.datumB')}}{{izbranZapis[0].datum_brisanja}}</li>
          </ul>
          <!-- JADRALNA PODROBNO -->
          <ul class='list-group list-group-flush' v-else>
            <li class='list-group-item list-dark'>{{$t('modal.reg')}} {{izbranZapis[0].registracija}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.pilot')}} {{izbranZapis[0].pilot}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.regV')}} {{izbranZapis[0].reg_vleke}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.instruktor')}} {{izbranZapis[0].instruktor}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.namen')}} {{izbranZapis[0].namen}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.naloga')}} {{izbranZapis[0].naloga}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.casV')}} {{izbranZapis[0].cas_vzleta}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.casO')}} {{izbranZapis[0].cas_odklopa}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.casP')}} {{izbranZapis[0].cas_pristanka}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.casL')}} {{izbranZapis[0].cas_letenja}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.casVL')}} {{izbranZapis[0].cas_vleke}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.opomba')}} {{izbranZapis[0].tip}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.datumL')}} {{izbranZapis[0].datum}}</li>
            <li class='list-group-item list-dark'>{{$t('modal.datumV')}} {{izbranZapis[0].datum_vnosa}}</li>
            <li class='list-group-item border-lorange'>{{$t('modal.datumB')}} {{izbranZapis[0].datum_brisanja}}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<style>

.deleted-flights-container {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.flight-section {
  background: #151922;

  border: 1px solid #292f3b;
  border-radius: 14px;

  overflow: scroll;
  max-height: 40vh;
  box-shadow: 0 8px 30px rgba(0, 0, 0, .12);
}


.section-header {
  display: flex;
  align-items: center;
  gap: 12px;
  position:sticky;
  top: 0;
  padding: 17px 20px;
  background: #151922;
  z-index: 2;
  border-bottom: 1px solid #292f3b;
}

.section-header h2 {
  margin: 0;

  color: #fff;

  font-size: 1rem;
  font-weight: 600;
}

.section-header span {
  display: block;

  margin-top: 2px;

  color: #717b8b;

  font-size: .75rem;
}


.section-icon {
  width: 38px;
  height: 38px;

  flex: 0 0 38px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 10px;
}

.section-icon.glider {
  color: #70b7ff;
  background: rgba(64, 145, 220, .13);
}

.section-icon.motor {
  color: #a78bfa;
  background: rgba(139, 92, 246, .13);
}


.flight-list {
  padding: 7px;
}

.flight-item {
  display: grid;

  grid-template-columns: 1.2fr 1fr 1fr auto;

  align-items: center;

  gap: 20px;

  padding: 13px 15px;

  border-radius: 9px;

  cursor: pointer;

  transition:
      background .2s ease,
      transform .2s ease;
}

.flight-item:hover {
  background: #1e2530;
}

.flight-item + .flight-item {
  margin-top: 2px;
}

.flight-date {
  display: flex;
  align-items: center;
  gap: 9px;

  color: #b9c1cd;

  font-size: .85rem;
}

.flight-date i {
  color: #697586;
  width: 16px;
  text-align: center;
}

.label {
  display: block;

  margin-bottom: 3px;

  color: #667181;

  font-size: .68rem;
  text-transform: uppercase;
  letter-spacing: .04em;
}

.flight-user strong,
.flight-task strong {
  display: block;

  color: #dce2e9;

  font-size: .85rem;
  font-weight: 500;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.flight-task strong {
  color: #aeb9c8;
}

.flight-action {
  width: 32px;
  height: 32px;

  display: flex;
  align-items: center;
  justify-content: center;

  color: #687384;

  background: #202632;

  border-radius: 8px;

  transition: all .2s ease;
}

.flight-item:hover .flight-action {
  color: #fff;
  background: #344052;
  transform: translateX(2px);
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding: 35px;

  color: #687384;

  gap: 8px;
}

.empty-state i {
  font-size: 1.5rem;
}

.empty-state span {
  font-size: .85rem;
}


@media (max-width: 900px) {

  .flight-item {
    grid-template-columns: 1fr 1fr;
    gap: 12px;
  }

  .flight-action {
    position: absolute;
    right: 15px;
  }

  .flight-item {
    position: relative;
    padding-right: 55px;
  }
}


@media (max-width: 650px) {
  .deleted-flights-container {
    padding: 12px;
  }

  .flight-item {
    grid-template-columns: 1fr;
  }
}
</style>